import { InputAdornment, TextField } from '@mui/material';
import { getFieldLabel } from '../../utils';
import { useTranslation } from 'react-i18next';
import { FormFieldProps } from '.';
import { FieldHelperText } from './FieldHelperText';

export function StringField(props: FormFieldProps) {
  const {
    disabled,
    field,
    error,
    value,
    onChange,
    helperText,
    name,
    inputProps,
    isImported,
    sx,
  } = props;
  const { t } = useTranslation();
  const { unit, description, visibleLineCount } = field.fieldAttributes ?? {};

  return (
    <>
      <TextField
        {...props}
        disabled={disabled}
        fullWidth
        label={getFieldLabel({ field, t })}
        type="text"
        error={error}
        value={value}
        onChange={onChange}
        name={name}
        sx={{
          '& .MuiInputBase-root': {
            background: isImported ? theme => theme.palette.grey[200] : null,
          },
          ...sx,
        }}
        rows={visibleLineCount ?? 1}
        multiline={visibleLineCount !== undefined}
        InputProps={{
          endAdornment: unit && (
            <InputAdornment position="end">{unit}</InputAdornment>
          ),
          readOnly: inputProps?.readOnly ?? false,
        }}
        InputLabelProps={{ shrink: true }}
        helperText={
          <FieldHelperText
            description={description}
            helperText={helperText}
            error={error}
          />
        } />
    </>
  );
}
